import React from "react";
import {
  FaInstagram,
  FaTiktok,
  FaFacebookF,
  FaYoutube,
  FaWhatsapp,
} from "react-icons/fa";

export default function FooterComp() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const waLink =
    "https://wa.me/6282139397342?text=" +
    encodeURIComponent("kak saya mau join mitra idinvitebook");

const goToWa = () => {
    window.open(waLink, "_blank");
}
  return (
    <footer className="footer">
      {/* TOP */}
      <div className="footer-top">
        {/* LEFT */}
        <div className="about">
          <h1>idinvitebook</h1>

          <p>
            idinvitebook adalah platform digitalisasi pernikahan terpadu yang
            membuat pernikahanmu lebih efisien, efektif, bermakna, dan terkini.
          </p>

          <div className="contact">
            <h3>Layanan Pelanggan</h3>

            <a href="/">halo@idinvitebook.com</a>
            <a href="/">+6282139397342</a>
          </div>
        </div>

        {/* PAYMENT */}
        <div className="payment">
          <h2>Metode Pembayaran</h2>

          <div className="payment-grid">
            {[
              "BCA",
              "Mandiri",
              "BRI",
              "BNI",
              "BSI",
              "Permata",
              "OVO",
              "DANA",
              "GoPay",
            ].map((item, index) => (
              <div className="pay-card" key={index}>
                {item}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* MENU */}
      <div className="footer-menu">
        <div className="menu-col">
          <h3>Produk</h3>

          <a href="/">Undangan Digital</a>
          <a href="/">Buku Tamu Digital</a>
          <a href="/">Live Streaming</a>
        </div>

        <div className="menu-col">
          <h3>Bantuan</h3>

          <a href="/">FAQ</a>
          <a href="/">Syarat dan Ketentuan</a>
          <a href="/">Kebijakan Privasi</a>
          <a href="/">Kemitraan</a>
        </div>

        <div className="menu-col">
          <h3>Resources</h3>

          <a href="/">Desain Template</a>
          <a href="/">Blog</a>
        </div>

        <div className="menu-col">
          <h3>Ikuti Kami</h3>

          <div className="socials">
            <a href="/">
              <FaInstagram />
            </a>

            <a href="/">
              <FaTiktok />
            </a>

            <a href="/">
              <FaFacebookF />
            </a>

            <a href="/">
              <FaYoutube />
            </a>
          </div>
        </div>
      </div>

      {/* BOTTOM */}
      <div className="footer-bottom">
        <p>© Copyright {new Date().getFullYear()} All Rights Reserved</p>

        <div className="bottom-links">
          <a href="/">Pernyataan Hukum</a>
          <a href="/">Kebijakan Privasi</a>
        </div>
      </div>

      {/* FLOAT BUTTON */}
      <div className="floating-chat" onClick={goToWa}>
        <FaWhatsapp />
        <span>Chat</span>
      </div>

      <div className="scroll-top" onClick={scrollToTop}>
        ↑
      </div>

      <style>{`
        *{
          margin:0;
          padding:0;
          box-sizing:border-box;
        }

        body{
          font-family:Arial, sans-serif;
          background:#f7f7f7;
        }

        .footer{
          width:100%;
          background:#f7f7f7;
          border-top:1px solid #e8e8e8;
        }

        /* TOP */
        .footer-top{
          display:grid;
          grid-template-columns:1.2fr 1fr;
          border-bottom:1px solid #e8e8e8;
        }

        .about,
        .payment{
          padding:50px;
        }

        .payment{
          border-left:1px solid #e8e8e8;
        }

        .about h1{
          color:#ff0a8a;
          font-size:60px;
          font-style:italic;
          margin-bottom:24px;
        }

        .about p{
          font-size:18px;
          color:#575757;
          line-height:1.8;
          max-width:600px;
          margin-bottom:24px;
        }

        .license{
          display:block;
          color:#7c7c7c;
          margin-bottom:32px;
          line-height:1.7;
        }

        .contact h3{
          margin-bottom:16px;
          color:#222;
        }

        .contact a{
          display:block;
          text-decoration:none;
          color:#ff0a8a;
          margin-bottom:12px;
          font-size:18px;
        }

        .payment h2{
          font-size:36px;
          margin-bottom:32px;
          color:#222;
        }

        .payment-grid{
          display:grid;
          grid-template-columns:repeat(3,1fr);
          gap:16px;
        }

        .pay-card{
          height:64px;
          border:1px solid #f0d7e5;
          border-radius:16px;
          background:white;
          display:flex;
          align-items:center;
          justify-content:center;
          font-weight:700;
          color:#555;
          transition:0.3s;
        }

        .pay-card:hover{
          transform:translateY(-4px);
          box-shadow:0 10px 20px rgba(0,0,0,0.05);
        }

        /* MENU */
        .footer-menu{
          display:grid;
          grid-template-columns:repeat(4,1fr);
          border-bottom:1px solid #e8e8e8;
        }

        .menu-col{
          padding:50px;
          border-right:1px solid #e8e8e8;
        }

        .menu-col:last-child{
          border-right:none;
        }

        .menu-col h3{
          font-size:32px;
          margin-bottom:28px;
          color:#222;
        }

        .menu-col a{
          display:block;
          text-decoration:none;
          color:#686868;
          margin-bottom:18px;
          font-size:18px;
          transition:0.3s;
        }

        .menu-col a:hover{
          color:#ff0a8a;
        }

        .socials{
          display:flex;
          gap:14px;
        }

        .socials a{
          width:56px;
          height:56px;
          background:#f1f1f1;
          border-radius:14px;
          display:flex;
          align-items:center;
          justify-content:center;
          color:#ff0a8a;
          font-size:22px;
        }

        /* BOTTOM */
        .footer-bottom{
          display:flex;
          justify-content:space-between;
          align-items:center;
          padding:24px 50px;
          flex-wrap:wrap;
          gap:16px;
        }

        .footer-bottom p{
          color:#7a7a7a;
        }

        .bottom-links{
          display:flex;
          gap:24px;
        }

        .bottom-links a{
          text-decoration:none;
          color:#7a7a7a;
        }

        /* FLOAT */
        .floating-chat{
          position:fixed;
          right:24px;
          bottom:24px;
          background:#ff0a8a;
          color:white;
          padding:14px 22px;
          border-radius:999px;
          display:flex;
          align-items:center;
          gap:10px;
          font-weight:600;
          box-shadow:0 10px 25px rgba(255,10,138,0.35);
          cursor:pointer;
          z-index:99;
        }

        .scroll-top{
          position:fixed;
          right:24px;
          bottom:90px;
          width:54px;
          height:54px;
          border-radius:50%;
          background:#ff0a8a;
          color:white;
          display:flex;
          align-items:center;
          justify-content:center;
          font-size:24px;
          cursor:pointer;
          z-index:99;
        }

        /* MOBILE */
        @media(max-width:992px){

          .footer-top{
            grid-template-columns:1fr;
          }

          .payment{
            border-left:none;
            border-top:1px solid #e8e8e8;
          }

          .footer-menu{
            grid-template-columns:1fr 1fr;
          }
        }

        @media(max-width:768px){

          .about,
          .payment,
          .menu-col{
            padding:28px 20px;
          }

          .about h1{
            font-size:44px;
          }

          .payment h2,
          .menu-col h3{
            font-size:26px;
          }

          .payment-grid{
            grid-template-columns:1fr 1fr;
          }

          .footer-menu{
            grid-template-columns:1fr;
          }

          .menu-col{
            border-right:none;
            border-bottom:1px solid #e8e8e8;
          }

          .footer-bottom{
            padding:20px;
            flex-direction:column;
            align-items:flex-start;
          }

          .floating-chat{
            right:16px;
            bottom:16px;
          }

          .scroll-top{
            right:16px;
            bottom:84px;
          }
        }
      `}</style>
    </footer>
  );
}
